import { EventMeta, hasMeta } from '@/utils/events.utils'
import { composeTheme } from '@css-modules-theme/core'
import sharedEventStyles from '@/styles/templates/Events.module.css'
import eventStyles from '@/app/_components/EventHeader/EventHeader.module.css'
import { ReactNode } from 'react'
import TXT from '@/messages'

type Props = {
  meta: EventMeta
}

const SupportingActs = ({ meta }: Props): ReactNode => {
  const styles = composeTheme([
    { theme: sharedEventStyles },
    { theme: eventStyles },
  ])

  const hasSupportingActs = hasMeta('supportingActs', meta)

  if (!hasSupportingActs) {
    return null
  }

  return (
    <div data-testid="supporting-acts">
      <h3 className={styles.EventSubhead}>
        {TXT.eventsPage.guestActs}
      </h3>
      <div className={styles.EventSupportingAct}>
        {meta.supportingActs}
      </div>
    </div>
  )
}

export default SupportingActs
